import React, { useState } from 'react';
import '../offers/offers.css';
import { AiOutlineArrowDown} from 'react-icons/ai';

const ProductItem = ({ image, title, description, link }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <div className='offers__item' id='new'>
      <img src={image} alt={title} title={title} className='offers__img' width="400" height="400" />
      <div>
        <div className='offers__item-title'>
          <h4>{title}</h4>
          <div className='product-description'>
            <span>
              {isExpanded ? description : `${description.slice(0, 110)}... `}
            </span>
            <button className="read-more-btn" onClick={toggleReadMore}>
              {isExpanded ? "Read Less" : "Read More"}
            </button>
          </div>
        </div>
        <div className='new-buttons'>
          <a className='offers__items_link' href='#contact'>Book Now</a>
          <a className='offers__items_link2' href='#price'>
            Prices
            <AiOutlineArrowDown className='service__button-icon'/>
          </a>
        </div>
      </div>
    </div>
  );
};

const New = () => {
  const products = [
    {
      image: require('../../assets/new/Bio-Penta.png'),
      title: "Bio-Penta",
      description: "The Bio-Penta® by Bio-Therapeutic, launching internationally in late 2018, combines five advanced skincare technologies into one innovative device. Microsonic Cleansing – Features a Blue Azul silver ion-infused silicone brush for antimicrobial and antibacterial cleansing. Wet/Dry Microdermabrasion – Delivers deep exfoliation, skin smoothing, and tightening. LED Light Therapy – Offers RED (640nm) and BLUE (470nm) light for age management and blemish care. Ultrasound & Microcurrent – Enhances product absorption with proprietary programming. Bespoke Protocols – Designed specifically for customized treatments with Bio-Penta. Its touchscreen interface makes operation intuitive, and each technology can be used separately or combined to create the Ultimate Layered Facial. With a sleek, modern design and compact size, the Bio-Penta is a must-have for forward-thinking skin therapists.",
    },
    {
      image: require('../../assets/new/bt-titan.png'),
      title: "bt-titan®MN",
      description: "The bt-titan MN model AE delivers a highly controlled and precise service tailored to each person's skin needs and comfort. Unlike invasive procedures, this quick microexfoliation treatment provides visible results while being suitable for most skin types and tones. With no downtime, it's perfect for clients with busy schedules. Treat your clients to radiant, luminous skin with the bt-titan MN. Includes: bt-titan MN – Precision microexfoliation system, FREE AquaFuse Tech Peel (4oz) – Advanced exfoliant, FREE bt-titan MN Nano Tip Cartridge (20 pack) – Non-invasive exfoliation.",
    },
    {
      image: require('../../assets/new/bt-nano.png'),
      title: "bt-nano",
      description: "The bt-nano is the ultimate mini facial toning system, featuring our exclusive patented Suzuki Sequencing® platform and convenient preset programming. This compact, award-winning device is a favorite among advanced skin practitioners for its unparalleled results, versatility, and profitability. It supports both short and extended microcurrent facial toning services. bt-sculpt PRO: The bt-sculpt PRO is a facial electrode probe accessory for use with the Bio-Ultimate Platinum and bt-nano microcurrent systems. Designed to replace standard probes, it offers superior versatility and enables single-handed microcurrent facial lifting, toning, and skin work. Simply plug the bt-sculpt PRO into the bt-nano's DIN receptacle for enhanced lifting and toning results.",
    },
    {
      image: require('../../assets/new/bt-sculpt.png'),
      title: "bt-sculpt",
      description: "From microcurrent pioneer Bio-Therapeutic comes a revolutionary facial sculpting device, delivering professional-grade lifting and firming in a rechargeable, handheld unit. Featuring patented Suzuki Sequencing®, developed over 50 years, this advanced technology energizes the skin, promoting a firmer, more lifted appearance. The patent-pending K4iTEK™ self-tensioning probe system allows for one-handed application with precise, comfortable lifting pressure. Four independently controlled energy pathways and ultra-pure martensitic stainless steel probe heads ensure superior coverage—just like Bio-Therapeutic’s professional models.",
    },
    {
      image: require('../../assets/new/bt-micro fusion.png'),
      title: "bt-micro fusion",
      description: "The new bt-micro fusion delivers exceptional ultrasonic power, bringing professional results into the home care regimen. For the first time, Bio-Therapeutic’s legendary bt-micro technology is available for home use! The new bt-micro fusion is the ideal skin perfecting tool for exfoliation and product application, featuring industry leading ultrasonic power in a compact, water resistant handheld unit. Built for beauty and designed to perform, the bt-micro fusion combines sublime detailing, durable alloy construction, and perfect balance, making it ideal for home use. Intuitive 2 button control gives quick access to 3 modes and 2 power levels, while the LED indicators show exactly where you are at a glance, and the new battery design affords longer use time between charges.",
    }
  ];

  return (
    <section className='offers section' id='offers'>
      <h2 className='section__title'>New In</h2>
      <h3 className='section__subtitle'>Our latest products and services</h3>
      <div className='offers__items container grid new'>
        {products.map((product, index) => (
          <ProductItem key={index} {...product} />
        ))}
      </div>
      <div className='youtube-video'>
        <iframe width="80%" height="600"  src="https://player.vimeo.com/video/916129087?h=cc7f3c73be&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" title="BT-SCULPT_PRO_Anim_16x9_GLOREV020124"></iframe>
        </div><script src="https://player.vimeo.com/api/player.js"></script>
    </section>
  );
};

export default New;